import {district} from '@/api-services'
import {errorHandler} from '@/utils/handler'
import {toast} from '@/utils/toast'
import {defineStore} from 'pinia'

export const useDistrictStore = defineStore('districtStore', {
  state: () => ({
    allDistricts: [],
    districtDetail: {},
    loading: false,
    error: null,
  }),
  actions: {
    async getAllDistricts() {
        this.loading = true
        const districts = localStorage.getItem('districts')
        if (districts) {
          this.allDistricts = JSON.parse(districts)
        } else {
          try {
            const response = await district.getAllDistrict()
            const data = response.data
            this.allDistricts = data
            localStorage.setItem('districts', JSON.stringify(data))
          } catch (error) {
            error.map((e) => {
              const errorMsg = errorHandler(e)
              this.error = errorMsg
              toast.error(errorMsg)
            })
          } finally {
            this.loading = false
          }
        }
    },
  },
})
